module.exports = __webpack_public_path__ + "media/images/icon__betPick--censored@3x-47ef54963423ce74072b49ffe5bb4261.png";